<!--
 * @Descripttion:
 * @version:
 * @Author: kun.zhang
 * @Date: 2021-09-10 14:43:08
 * @LastEditors: yingna.gao
 * @LastEditTime: 2023-02-03 19:19:37
-->
<template>
  <div class="scim-common-app-header">
    <div class="app-header-left" @click="goToHome">
      <div class="app-header-logo">
        <img v-if="title.fileUrl" :src="title.fileUrl" style="width: 100%" alt="" />
        <!-- <img v-else :src="titleDefaultPicture" style="width: 100%" alt="" /> -->
        <svg-icon v-else icon-class="logo" class="logo-svg"></svg-icon>
      </div>

      <span class="app-header-title">{{ title.headerTitle || title.applicationName }}</span>
      <div v-if="title.adminId === userInfo.id" class="app-header-edit">
        <svg-icon icon-class="edit" @click="handleEditShow"></svg-icon>
      </div>
    </div>
    <div class="right-menu">
      <template>
        <span v-if="toDoShow" class="right-menu-item">
          <!-- <el-badge :value="12" class="item"> -->
          <svg-icon icon-class="toDo" class="toDo-icon cursor-p"></svg-icon>
          <!-- </el-badge> -->
        </span>
        <span v-if="messageShow" class="right-menu-item">
          <svg-icon icon-class="message-home" class="message-home-icon cursor-p" />
        </span>
        <span v-if="warnshow" class="right-menu-item">
          <svg-icon icon-class="warn" class="warn-icon cursor-p"></svg-icon>
        </span>
        <el-popover v-model="$store.state.settings.showExportTask" placement="bottom-end" width="550" trigger="hover">
          <div class="import-export-content">
            <el-tabs v-model="importOrExportType">
              <el-tab-pane label="导入" name="import">
                <excel-import key="import" :list="importList" type="import"></excel-import>
              </el-tab-pane>
              <el-tab-pane label="导出" name="export">
                <excel-import key="export" :list="exportList" type="export"></excel-import>
              </el-tab-pane>
            </el-tabs>
            <div class="primary-color text-right py-2 pr-4 cursor-pointer" @click="goExcelRecord">
              查看所有任务
            </div>
          </div>
          <svg-icon
            slot="reference"
            icon-class="import-export"
            class="mr-1 cursor-pointer"
          ></svg-icon>
        </el-popover>
        <screenfull id="screenfull" class="right-menu-item cursor-pointer" />
        <el-divider class="right-menu-item split-line" direction="vertical"></el-divider>
        <svg-icon v-if="belongOrgName" icon-class="org" class="mr-2"></svg-icon>
        <span>{{ belongOrgName }}</span>
        <!-- <el-dropdown v-if="orgList.length" trigger="hover" data-key="dropdown" @visible-change="visibleChange">
          <span class="cursor-pointer" :class="{ 'active': dropdownVisible }">
            {{ currentOrgName }}<i class="el-icon-arrow-down ml-1"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item, index) in orgList" :key="item.id || index">
              <div class="dropdown-item w-40 flex justify-between items-center" :class="{ 'active': item.select }" @click="changeOrg($event, item)">
                <span>{{ item.span }}</span>
                <i class="el-icon-check"></i>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <el-popover
          placement="bottom"
          trigger="hover"
          popper-class="scim-common-theme scim-common-theme-green"
          class="right-menu-item"
          :visible-arrow="false"
        >
          <div slot="reference" class="avatar-container">
            <div class="avatar-wrapper">
              <div v-if="userInfo.displayName" class="user-avatar">
                {{ userInfo.displayName.slice(0, 1) }}
              </div>
            </div>
          </div>
          <div class="self-popover-items w-28">
            <p class="self-popover-item">{{ userInfo.displayName }}</p>
            <p class="self-popover-item">{{ userInfo.cellphone }}</p>
            <p class="self-popover-item" @click="passDialogVisible = true">
              {{ $t('userCenter.changePassword') }}
            </p>
            <p class="self-popover-item" @click="show = !show">{{ $t("home.pageSetting") }}</p>
            <p class="self-popover-item" @click="logoutEDM">{{ $t('navbar.logOut') }}系统</p>
          </div>
        </el-popover>
      </template>
    </div>
    <right-panel :show.sync="show">
      <settings />
    </right-panel>
    <edit-app
      :visible.sync="editDialogVisible"
      :prop-data="editFormData"
      :prop-loading="editLoading"
      @confirm="handleEditConfirm"
    >
      <template #desc>
        <span class="logo-desc">建议尺寸：高度48、宽度在50 - 200之间；</span>
      </template>
    </edit-app>
    <!-- <rc-dialog
      :title="$t('userCenter.changePassword')"
      v-bind="dialog"
      :visible.sync="passDialogVisible"
      :append-to-body="true"
      :disabled="passDisabled"
      class="dialog-visible"
      :validate-state="validateState"
      @dialog-confirm="changePassword"
    /> -->
    <change-password
      v-if="passDialogVisible"
      :visible.sync="passDialogVisible"
      :show-close="initPasswordChange"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

/* import { generateTitle } from "@/utils/i18n";*/
import { getLang } from "@/utils/auth";
import Screenfull from "@/components/common/Screenfull";
import RightPanel from "@/components/common/RightPanel";
import EditApp from "@/views/standard/home/components/editApp";
import Settings from "@/layout/components/Settings/index";
import { application } from "@/api/other/sysManage";
import { edmDefaultPicture } from "@/utils/base64svg";
import user from "@/api/user/user";
import otherUser from "@/api/other/user";
import JSEncrypt from "jsencrypt";
import { rulesRequired, rulesCheckTwoField } from "@/utils";
import ExcelImport from "./ExcelRecord/import";
import ExcelApi from "@/api/excel";
import ChangePassword from "./changePassword";
export default {
  name: "AppHeader",
  components: {
    Screenfull,
    RightPanel,
    Settings,
    EditApp,
    ExcelImport,
    ChangePassword
  },
  props: {
    clickNotClose: {
      default: false,
      type: Boolean
    },
    buttonTop: {
      default: 250,
      type: Number
    }
  },
  data() {
    const checkPassword = (rule, value, callback) => {
      rulesCheckTwoField({ rule, value, callback, checkVal: this.dialog.data.newPassword });
    };

    return {
      timer: null,
      dropdownVisible: false,
      importOrExportType: "import",
      lang: getLang(),
      show: false,
      toDoShow: false,
      warnshow: false,
      importList: [],
      exportList: [],
      messageShow: false,
      editDialogVisible: false,
      editLoading: false,
      editFormData: {},
      orgList: [],
      currentOrgName: "",
      passDialogVisible: false,
      publicKey: undefined,
      dialog: {
        title: this.$t("userCenter.changePassword"),
        contentType: "form",
        imgIcon: "success",
        paramsStructure: this.paramsStructure,
        data: {
          oldPassword: "",
          newPassword: "",
          checkNewPassword: ""
        },
        formItem: [
          {
            component: "rc-input",
            label: "输入登录密码",
            placeholder: "请输入登录密码",
            prop: "oldPassword",
            type: "password",
            span: 24,
            rules: [rulesRequired({ message: "请输入登录密码" })]
          },
          {
            component: "rc-input",
            label: "输入新密码",
            placeholder: "请输入新密码",
            type: "password",
            prop: "newPassword",
            span: 24,
            rules: [rulesRequired({ message: "请输入新密码" })]
          },
          {
            component: "rc-input",
            label: "重复新密码",
            placeholder: "请输入",
            type: "password",
            prop: "checkNewPassword",
            rules: [
              rulesRequired({ message: "请输入" }),
              { validator: checkPassword, trigger: ["change", "blur"] }
            ]
          }
        ]
      },
      dialogConfirmState: false,
      belongOrgName: this.$store.getters.infoData.belongOrgName,
      initPasswordChange: false
    };
  },
  computed: {
    ...mapGetters(["sidebar", "userInfo", "company", "isSystem", "title", "tenantId"]),
    userCenter() {
      return window.env.userCenter;
    },
    size() {
      return this.$store.getters.size;
    },
    titleDefaultPicture() {
      return edmDefaultPicture;
    }
  },
  watch: {
    lang: {
      handler(val) {
        this.$store.commit("settings/CHANGE_LANG", val);
      },
      immediate: true
    },
    "$store.state.settings.toDoShow"(newValue, oldValue) {
      this.toDoShow = newValue;
    },
    "$store.state.settings.warnshow"(newValue, oldValue) {
      this.warnshow = newValue;
    },
    "$store.state.settings.messageShow"(newValue, oldValue) {
      this.messageShow = newValue;
    },
    "$store.state.settings.showExportTask"(newValue) {
      if (newValue) {
        this.loadData();
        // 开启定时
        this.timer = setInterval(this.loadData, 20000);
      }
    }
  },
  created() {
    // this.getSetting();
    this.isChangePasswordFun();
    this.initPublicKey();
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    this.loadOrgList();

    // qiankun 通信
    this.$actions.onGlobalStateChange((state, prevState) => {
      if (state.excelRecord && state.excelRecord.show) {
        this.$store.commit("settings/CHANGE_EXPORT_TASK", true);
        const { type } = state.excelRecord;
        this.importOrExportType = type || "import";

        // 恢复默认
        this.$actions.setGlobalState({ excelRecord: { show: false, type: "import" }});
      }
    });
  },
  methods: {
    isChangePasswordFun() {
      otherUser.modifyPassword().then(res => {
        if (res.success) {
          this.$set(this, "initPasswordChange", Boolean(res.data));
          this.$set(this, "passDialogVisible", Boolean(res.data));
        }
      });
    },
    loadData() {
      this.loadExcelList();
      this.loadExcelList("export");
    },
    loadExcelList(type = "import") {
      const params = {
        type: type.toUpperCase(),
        page: 1,
        size: 5,
        "orders[0].asc": false,
        "orders[0].column": "createTime",
        createBy: this.userInfo.id
      };

      // if (type === 'export') {
      //   params.state = 'SUCCEED';
      // }
      ExcelApi.importExcelRecord(params).then(res => {
        if (res.success) {
          const { data } = res;
          if (data) {
            const { records = [] } = data;
            const unGetAttachmentId = records.some(tem => !tem.attachmentId);
            if (!unGetAttachmentId) {
              clearInterval(this.timer);
              this.timer = null;
            }
            this[`${type}List`] = records;
          }
        }
      });
    },
    // 初始化公钥
    initPublicKey() {
      otherUser.getPublicKey().then(res => {
        const { data } = res;
        this.publicKey = data;
      });
    },
    changePassword({ data, valid }) {
      // 公钥不存在
      if (!this.publicKey) {
        this.$message.error(this.$t("login.publicKeyError"));
        return;
      }
      if (valid) {
        const encryptJs = new JSEncrypt();
        encryptJs.setPublicKey(this.publicKey);
        const { userInfo } = this.$store.state.user;
        const params = {
          authenticatedBy: "password",
          newPassword: encryptJs.encrypt(data.newPassword),
          options: {
            id: userInfo.id,
            oldPassword: encryptJs.encrypt(data.oldPassword)
          },
          passwordEncrypted: true
        };
        user.changePassword(params).then(() => {
          this.$message.success("修改密码成功");
          this.logoutEDM();
        });
      }
    },
    async loadOrgList() {
      const orgIds = this.$store.state.user.orgId;
      if (!Array.isArray(orgIds) || !orgIds.length) {
        return;
      }
      const params = { keys: this.$store.state.user.orgId };
      const { data } = await user.getOrgLists(params);

      if (Array.isArray(data)) {
        this.orgList = data.map(item => {
          const { tenantId, orgName } = item;
          let select = false;
          if (this.tenantId === tenantId) {
            this.currentOrgName = orgName;
            select = true;
          }

          return {
            span: orgName,
            orgId: tenantId,
            select
          };
        });
      }
    },
    changeOrg(event, item) {
      event.stopPropagation();
      event.preventDefault();
      const params = { orgId: item.orgId };
      user.changeOrg(params).then(() => {
        location.reload();
      });
    },
    visibleChange(visible) {
      this.dropdownVisible = visible;
    },
    /* generateTitle,*/
    handleChangeLang(lang) {
      this.lang = lang;
      location.reload();
    },
    goToHome() {
      this.$router.push({ path: "/dashboard" });
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logoutEDM() {
      await this.$store.dispatch("user/logout");
      this.$router.push({ path: "/login" });
    },
    toUserCenter() {
      this.$router.push(this.userCenter);
    },
    goExcelRecord() {
      this.$router.push({ name: "ExcelImportRecord" });
    },

    /*
     * getSetting() {
     *   application.getUserSetting().then((res) => {
     *     if (res.code === 200) {
     *       const data = res.data.labelShow;
     *       if (data && data.length > 0) {
     *         if (data.includes("toDoShow")) {
     *           this.toDoShow = true;
     *         }
     *         if (data.includes("warnshow")) {
     *           this.warnshow = true;
     *         }
     *         if (data.includes("messageShow")) {
     *           this.messageShow = true;
     *         }
     *       }
     *     }
     *   });
     * },
     * 编辑标题
     */
    handleEditShow() {
      this.editFormData = {
        applicationName: this.title.headerTitle,
        applicationIcon: this.title.fileUrl,
        type: "title"
      };
      this.editDialogVisible = true;
    },
    // 确认编辑标题
    handleEditConfirm(data) {
      this.editLoading = true;
      const formData = new FormData();
      formData.append("logoIcon", data.applicationIcon);
      formData.append("appName", data.applicationName);
      formData.append("file", data.file);
      application
        .updateTenant(formData)
        .then(res => {
          if (res.code === 200) {
            this.$message.closeAll();
            this.$store
              .dispatch("user/getTitle")
              .then(() => {
                this.$message.success("编辑成功");
                this.editLoading = false;
                this.editDialogVisible = false;
              })
              .catch(() => {
                this.editLoading = false;
              });
          }
        })
        .catch(() => {
          this.editLoading = false;
        });
    },
    passDisabled({ prop }) {
      return prop === "confirm" && !this.dialogConfirmState;
    },
    paramsStructure(params, { data }) {
      const { userInfo } = this.$store.state.user;
      const { newPassword, oldPassword } = params;
      const formData = {
        authenticatedBy: userInfo.id,
        newPassword,
        oldPassword
      };
      return formData;
    },
    validateState({ state }) {
      this.dialogConfirmState = state;
    }
  }
};
</script>

<style lang="scss" scoped>
$weightText: #21252e;
$themeGreen: #00b259;

.scim-common-app-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 56px;
  overflow: hidden;
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  z-index: 1002;
  .app-header-left {
    height: 100%;
    display: flex;
    padding-left: 20px;
    cursor: pointer;
    .app-header-logo {
      display: flex;
      align-items: center;
      margin-right: 6px;
      width: 136px;
      height: 100%;
      .logo-svg {
        width: 100%;
        height: 20px;
      }
    }
    .app-header-title {
      line-height: 52px;
      font-size: 18px;
      font-weight: 600;
      color: $weightText;
    }
    &:hover {
      .app-header-edit {
        display: flex;
      }
    }
    .app-header-edit {
      margin-left: 8px;
      height: 100%;
      display: none;
      align-items: center;
      color: #9da5b2;
      font-size: 16px;
      &:hover {
        color: #505363;
      }
    }
  }

  .avatar-container {
    height: 100%;
    display: flex;
    align-items: center;

    .avatar-wrapper {
      height: 32px;
      position: relative;
      cursor: default;
      .user-avatar {
        width: 32px;
        height: 32px;
        border-radius: 16px;
        background-color: #00b259;
        text-align: center;
        align-items: center;
        line-height: 30px;
        font-size: 14px;
        color: #fff;
      }
    }
    .pover_nopointer {
      cursor: default;
    }
  }

  .cut-line {
    padding-right: 30px;
    position: relative;
    &:after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      height: 30px;
      transform: translateY(-50%);
      width: 1px;
      background: #ddd;
    }
  }
}

.right-menu {
  height: 100%;
  line-height: 50px;
  display: flex;
  align-items: center;

  &:focus {
    outline: none;
  }

  .right-menu-item {
    display: inline-block;
    margin: 0 8px;
    color: #5a5e66;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      //transition: background .3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  .split-line {
    height: 2em;
  }

  .avatar-container {
    margin: 0 10px 0 2px;

    .avatar-wrapper {
      margin-top: -8px;
      position: relative;

      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        line-height: 34px;
        border-radius: 20px;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}

.rightPanel-background {
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);
  background: rgba(0, 0, 0, 0.2);
  z-index: -1;
}

.rightPanel {
  width: 100%;
  max-width: 260px;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
  transition: all 0.25s cubic-bezier(0.7, 0.3, 0.1, 1);
  transform: translate(100%);
  background: #fff;
  z-index: 40000;
}

.show {
  transition: all 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);

  .rightPanel-background {
    z-index: 20000;
    opacity: 1;
    width: 100%;
    height: 100%;
  }

  .rightPanel {
    transform: translate(0);
  }
}

.handle-button {
  width: 48px;
  height: 48px;
  position: absolute;
  left: -48px;
  text-align: center;
  font-size: 24px;
  border-radius: 6px 0 0 6px !important;
  z-index: 0;
  pointer-events: auto;
  cursor: pointer;
  color: #fff;
  line-height: 48px;
  i {
    font-size: 24px;
    line-height: 48px;
  }
}
.message-home-icon,
.toDo-icon,
.warn-icon {
  font-size: 24px;
}
.company-title {
  max-width: 230px;
  span {
    display: block;
    max-width: 230px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
  }
}

.cursor-pointer {
  i {
    transition: all 0.25s;
  }
  &.active {
    i {
      transform: rotate(180deg);
    }
  }
}
</style>

<style lang="scss">
.el-badge__content.is-fixed {
  top: 8px !important;
}
.el-badge__content {
  height: 18px !important;
  line-height: 18px !important;
  padding: 0 2px !important;
}
.logo-desc {
  font-size: 12px;
  font-weight: 400;
  color: #9ea5b2;
  margin-left: 27px;
}

.dropdown-item {
  i {
    color: #00b259;
    display: none;
  }

  &.active {
    i {
      display: inline-block;
    }
  }
}

.el-dropdown-menu {
  .popper__arrow {
    display: none !important;
  }
}
.dialog-visible {
  .el-icon-success {
    color: $scim-color-primary;
  }
}
.import-export-content {
  .el-tabs__header {
    margin: 0 !important;
  }
  .el-tabs__item {
    padding: 0 15px !important;
  }
}
</style>
